/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StreakStatus } from './StreakStatus';
import {
    StreakStatusFromJSON,
    StreakStatusFromJSONTyped,
    StreakStatusToJSON,
    StreakStatusToJSONTyped,
} from './StreakStatus';

/**
 * 
 * @export
 * @interface StreakPauseResponse
 */
export interface StreakPauseResponse {
    /**
     * 
     * @type {StreakStatus}
     * @memberof StreakPauseResponse
     */
    status: StreakStatus;
    /**
     * 
     * @type {number}
     * @memberof StreakPauseResponse
     */
    pausedAt: number | null;
}



/**
 * Check if a given object implements the StreakPauseResponse interface.
 */
export function instanceOfStreakPauseResponse(value: object): value is StreakPauseResponse {
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('pausedAt' in value) || value['pausedAt'] === undefined) return false;
    return true;
}

export function StreakPauseResponseFromJSON(json: any): StreakPauseResponse {
    return StreakPauseResponseFromJSONTyped(json, false);
}

export function StreakPauseResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StreakPauseResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'status': StreakStatusFromJSON(json['status']),
        'pausedAt': json['pausedAt'],
    };
}

export function StreakPauseResponseToJSON(json: any): StreakPauseResponse {
    return StreakPauseResponseToJSONTyped(json, false);
}

export function StreakPauseResponseToJSONTyped(value?: StreakPauseResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': StreakStatusToJSON(value['status']),
        'pausedAt': value['pausedAt'],
    };
}

